export default __webpack_public_path__ + "static/media/GetHelp_01.a3aba502.png";